import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastElement!: HTMLElement;
  private renderer: Renderer2;
  private hideTimer: any;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);

    this.toastElement = this.renderer.createElement('div');
    this.renderer.addClass(this.toastElement, 'app-toast');

    // styling
    this.renderer.setStyle(this.toastElement, 'position', 'absolute');
    this.renderer.setStyle(this.toastElement, 'bottom', '24px');
    this.renderer.setStyle(this.toastElement, 'right', '24px');
    this.renderer.setStyle(this.toastElement, 'display', 'flex');
    this.renderer.setStyle(this.toastElement, 'align-items', 'center');
    this.renderer.setStyle(this.toastElement, 'gap', '12px');
    this.renderer.setStyle(this.toastElement, 'padding', '12px 16px');
    this.renderer.setStyle(this.toastElement, 'background', '#4a4a4a');
    this.renderer.setStyle(this.toastElement, 'border', '1px solid #e4e4e7');
    this.renderer.setStyle(this.toastElement, 'border-radius', '10px');
    this.renderer.setStyle(this.toastElement, 'box-shadow', '0 8px 20px rgba(0,0,0,0.08)');
    this.renderer.setStyle(this.toastElement, 'font-size', '14px');
    this.renderer.setStyle(this.toastElement, 'color', '#fff');
    this.renderer.setStyle(this.toastElement, 'z-index', '9999');
    this.renderer.setStyle(this.toastElement, 'min-width', '260px');
    this.renderer.setStyle(this.toastElement, 'max-width', '360px');
    this.renderer.setStyle(this.toastElement, 'opacity', '0');
    this.renderer.setStyle(this.toastElement, 'transition', 'opacity 0.2s');
    this.renderer.setStyle(this.toastElement, 'pointer-events', 'none');

    document.body.appendChild(this.toastElement);
  }

  show(message: string, duration = 2000) {
    clearTimeout(this.hideTimer);

    // clear previous content
    this.toastElement.innerHTML = '';

    const isDark = document.documentElement.classList.contains('dark');

  this.renderer.setStyle(
    this.toastElement,
    'background',
    isDark ? '#4a4a4a' : '#fff'
  );

  this.renderer.setStyle(
    this.toastElement,
    'border',
    isDark ? '1px solid #3f3f46' : '1px solid #e4e4e7'
  );

  this.renderer.setStyle(
    this.toastElement,
    'color',
    isDark ? '#fff' : '#18181b'
  );

    // ✔ Icon
    const icon = this.renderer.createElement('div');
    icon.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" fill="#22c55e"></circle>
        <path d="M7.5 12.5l2.8 2.8L16.8 8.8" fill="none" stroke="#ffffff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;

    // Message
    const text = this.renderer.createElement('div');
    this.renderer.setStyle(text, 'flex', '1');
    text.innerText = message;

    // Close Button
    const closeBtn = this.renderer.createElement('button');
    closeBtn.innerHTML = '×';

    this.renderer.setStyle(closeBtn, 'border', 'none');
    this.renderer.setStyle(closeBtn, 'background', 'transparent');
    this.renderer.setStyle(closeBtn, 'cursor', 'pointer');
    this.renderer.setStyle(closeBtn, 'font-size', '16px');
    this.renderer.setStyle(
      closeBtn,
      'color',
      isDark ? '#a1a1aa' : '#71717a'
    );

    closeBtn.onclick = () => this.hide();

    this.renderer.appendChild(this.toastElement, icon);
    this.renderer.appendChild(this.toastElement, text);
    this.renderer.appendChild(this.toastElement, closeBtn);

    // show toast
    this.renderer.setStyle(this.toastElement, 'opacity', '1');

    this.hideTimer = setTimeout(() => {
      this.hide();
    }, duration);
  }

  hide() {
    clearTimeout(this.hideTimer);
    this.renderer.setStyle(this.toastElement, 'opacity', '0');
  }
}